import { FaQuestionCircle } from "react-icons/fa";

// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 140,
  type: "faq_list",
  name: "FAQ",
  category: "Content",
  icon: FaQuestionCircle,
  description: "Questions and answers shoppers can open one at a time",
  defaultSettings: {
    heading: "Frequently asked questions",
    subtitle: "",
    openFirst: true,
    items: [
      { id: "faq_sample_1", question: "How long does delivery take?", answer: "Most orders arrive in 2 to 4 working days. Big cities are often faster." },
      { id: "faq_sample_2", question: "Can I pay cash on delivery?", answer: "Yes. Pay the courier when your order arrives. Bank transfer is also available." },
      { id: "faq_sample_3", question: "What if the size is wrong?", answer: "Contact us within 7 days of delivery and we will help you exchange it." },
    ],
  },
  presets: [
    {
      name: "Delivery & payment FAQ",
      description: "Common questions about shipping, COD, and returns",
      settings: {},
    },
    {
      name: "Product care FAQ",
      description: "Questions about materials, washing, and storage",
      settings: {
        heading: "Caring for your order",
        items: [
          { id: "faq_care_1", question: "How should I wash it?", answer: "Hand wash in cold water and dry in the shade to keep colors bright." },
          { id: "faq_care_2", question: "Can I iron it?", answer: "Yes, on low heat with the garment turned inside out." },
        ],
      },
    },
  ],
  fields: [
    { key: "heading", label: "Heading", type: "text" },
    { key: "subtitle", label: "Subtitle", type: "text" },
    { key: "openFirst", label: "Open the first answer", type: "toggle" },
    {
      key: "items",
      label: "Questions",
      type: "blocks",
      itemName: "question",
      max: 20,
      summary: { title: "question", text: "answer" },
      defaultItem: { question: "New question", answer: "" },
      fields: [
        { key: "question", label: "Question", type: "text" },
        { key: "answer", label: "Answer", type: "textarea" },
      ],
    },
  ],
};

export default definition;
